import { Link } from 'react-router-dom';
import { useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { logEvent } from 'firebase/analytics';

import useContent from '@/localization/data_export';
import { getNewsList } from '@/network/apis/apiUri';
import analytics from '@/routes/firebase';
import VideoThumbnail from '@/components/video-thumnail';
import BroadCastAt from '@/components/broadcast-at';

export default function News() {
  const { mode } = useSelector((state) => state);

  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const { isSuccess, data } = useQuery(
    ['main', 'news'],
    async () => {
      const headResponse = await getNewsList({
        lan_code: mode,
        news_content_type: 2,
        page_info: {
          row_count: 1,
          number: 0,
        },
      });

      const topResponse = await getNewsList({
        lan_code: mode,
        is_list_allow: false,
        is_topstory: true,
        page_info: {
          row_count: 2,
          number: 0,
        },
      });

      const listResponse = await getNewsList({
        lan_code: mode,
        is_list_allow: false,
        start_reg_date: dayjs.tz().subtract(4, 'day').format('YYYY-MM-DD'),
        end_reg_date: dayjs.tz().format('YYYY-MM-DD'),
        page_info: {
          row_count: 9,
          number: 0,
        },
      });
      const headItem = headResponse.data.item[0];
      const topItems = topResponse.data.item;

      const ignoreId = [headItem.news_id, ...topItems.map((item) => item.news_id)];

      const listItems = listResponse.data.item.filter((item) => !ignoreId.includes(item.news_id)).slice(0, 6);

      return {
        head: {
          id: headItem.news_id,
          link: `/news/view?id=${headItem.news_id}`,
          image: headItem.image.url,
          title: headItem.title.find((v) => v.lan_code === mode).text,
          content: headItem.content.find((v) => v.lan_code === mode).text,
          duration: headItem.duration,
          date: headItem.broadcast_date,
        },
        top: topItems.map((item) => ({
          id: item.news_id,
          link: `/news/view?id=${item.news_id}`,
          image: item.image.url,
          title: item.title.find((v) => v.lan_code === mode).text,
          content: item.content.find((v) => v.lan_code === mode).text,
          duration: item.duration,
          date: item.broadcast_date,
        })),
        list: listItems.map((item) => ({
          id: item.news_id,
          link: `/news/view?id=${item.news_id}`,
          image: item.image.url,
          title: item.title.find((v) => v.lan_code === mode).text,
          content: item.content.find((v) => v.lan_code === mode).text,
          date: item.broadcast_date,
        })),
      };
    },
    {
      retry: false,
      enabled: !!mode,
      staleTime: 1000 * 60,
    }
  );

  return (
    <div>
      <h2 className="news-title">
        Latest <em>NEWS</em>
      </h2>
      <div className="news-content">
        {isSuccess && (
          <div className="top-news">
            <Link
              to={data.head.link}
              title={anchorTitle}
              onClick={() =>
                logEvent(analytics, 'select_item', {
                  item_list_name: `${data.head.title}`,
                  item_list_id: `news_${data.head.id}`,
                  items: [
                    {
                      item_id: `${data.head.id}`,
                      item_name: `${data.head.title}`,
                      item_brand: 'article',
                    },
                  ],
                })
              }
            >
              <div className="news-items">
                <VideoThumbnail thumbnail={data.head.image} duration={data.head.duration} />
                <h3>{data.head.title}</h3>
                <p>{data.head.content}</p>
                <BroadCastAt at={data.head.date} />
              </div>
            </Link>
          </div>
        )}
        {isSuccess &&
          data.top.map((item, index) => (
            <Link
              to={item.link}
              key={item.id}
              className="news-top-items"
              title={anchorTitle}
              data-index={index}
              onClick={() =>
                logEvent(analytics, 'select_item', {
                  item_list_name: `${item.title}`,
                  item_list_id: `news_${item.id}`,
                  items: [
                    {
                      item_id: `${item.id}`,
                      item_name: `${item.title}`,
                      item_brand: 'article',
                    },
                  ],
                })
              }
            >
              <VideoThumbnail thumbnail={item.image} duration={item.duration} />
              <h3>{item.title}</h3>
              <BroadCastAt at={item.date} />
            </Link>
          ))}
        <ul className="list-news">
          {isSuccess &&
            data.list.map((item) => (
              <li key={item.id}>
                <Link
                  to={item.link}
                  className="news-list-items"
                  title={anchorTitle}
                  onClick={() =>
                    logEvent(analytics, 'select_item', {
                      item_list_name: `${item.title}`,
                      item_list_id: `news_${item.id}`,
                      items: [
                        {
                          item_id: `${item.id}`,
                          item_name: `${item.title}`,
                          item_brand: 'article',
                        },
                      ],
                    })
                  }
                >
                  <h3>{item.title}</h3>
                  <BroadCastAt at={item.date} />
                </Link>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}
